import template from './loginPage.html';
import controller from './loginPage.controller';
import './loginPage.scss';

let loginPageComponent = {
  restrict: 'E',
  bindings: {
  },
  template,
  controller
};

export default loginPageComponent;
